import React from "react";
import BaseDefault from "../core/Base";


export default function UserDetails(){
    return(
        <BaseDefault
            title="Student and Teacher Management"
            styles="title"
        >
            <div className="home">
            
            </div>
        </BaseDefault>
    )
}